'use strict';

/**
 * @public getQuestionGroupAnswers
 * @returns {Array} answers - The grouped questions answers as an array of objects
 */
function getQuestionGroupAnswers() {
    return [...this.groupedQuestions].reduce((groupedQuestions, question) => {
        groupedQuestions.push({
            id: question.getAttribute(this.attributes.groupedQuestionId),
            answer: question.querySelector(this.CONST.selectors.form.input)?.value || 'skipped'
        });
        return groupedQuestions;
    }, []);
}

export { getQuestionGroupAnswers };
